import type { FloatingHeaderSettings, SurfaceStyle } from "@/cms/appearance";

export const floatingHeaderSurface = {
  backgroundColor: "var(--header-bg-color)",
  backgroundOpacity: 0.6,
  backdropBlur: 24,
  borderWidth: 1,
  borderColor: "var(--re-border, #ffffff20)",
  borderOpacity: 0.2,
  shadow: "2xl",
  shadowOpacity: 0.1,
} satisfies SurfaceStyle;

export const glassSearchSurface = {
  backgroundOpacity: 0.7,
  backdropBlur: 24,
  borderWidth: 1,
  borderColor: "var(--re-border, #ffffff30)",
  borderOpacity: 0.4,
  shadow: "xl",
  shadowOpacity: 0.2,
} satisfies SurfaceStyle;

export const editorialLabelSurface = {
  backgroundColor: "var(--label-bg-color)",
  backgroundOpacity: 0.6,
  backdropBlur: 24,
  borderWidth: 1,
  borderColor: "var(--re-border, #ffffff30)",
  borderOpacity: 0.3,
  shadow: "lg",
  shadowOpacity: 0.1,
} satisfies SurfaceStyle;

export function resolveSurface(
  defaults: SurfaceStyle,
  overrides?: SurfaceStyle,
): SurfaceStyle {
  return { ...defaults, ...overrides };
}

const floatingHeaderDefaults = {
  geometry: "floating",
  maxWidth: "1280px",
  top: "16px | 24px",
  inset: "16px | 48px",
  height: "58px",
  logoHeight: "24px",
  logoMode: "image",
  drawerWidth: "400px",
  angularFullWidth: true,
} satisfies FloatingHeaderSettings;

/** `floating.spacing`: the air above and beside a floating bar, mobile | desktop. */
export const floatingHeaderSpacing = {
  sm: { top: "8px | 12px", inset: "8px | 24px" },
  md: { top: "16px | 24px", inset: "16px | 48px" },
  lg: { top: "24px | 40px", inset: "24px | 96px" },
} satisfies Record<string, Pick<FloatingHeaderSettings, "top" | "inset">>;

/** Page offsets and the rendered header must resolve the same geometry. */
export function resolveFloatingHeaderSettings(
  options?: FloatingHeaderSettings,
) {
  return {
    ...floatingHeaderDefaults,
    ...floatingHeaderSpacing[options?.spacing ?? "md"],
    ...options,
    surface: resolveSurface(floatingHeaderSurface, options?.surface),
  };
}
